
import React, { Fragment } from "react";
import { Button } from "react-bootstrap";
import { NavLink, RouteComponentProps, withRouter } from "react-router-dom";
import {  UserBonusEvent, UserBonusStatus, UserBonusView } from "../../http/protocol";
import { getContainer } from "../../ioc/IOCSetup";
import { UserBonusEventService } from "../../services/UserBonusEventService";
import { UserBonusService } from "../../services/UserBonusService";
import { WalletService } from "../../services/WalletService";
import { ConfirmModal } from "../../util/ConfirmModal";
import { formatDate } from "../../util/date";
import { FormListener } from "../form/Form";
import { LoadingViewState, RouterView } from "../RouterView";
import { UserBonusEntriesList } from "./UserBonusEntriesList";
import UserBonusEventListView from "./UserBonusEventListView";


interface State extends LoadingViewState {
    userBonusId?: number;
    userId?: number;
    userBonusView? : UserBonusView;
    validationMap? : any;
    showCancelModal? : boolean;
}


export class UserBonusesView extends  RouterView<RouteComponentProps,State> implements FormListener<UserBonusView>{
    userBonusService: UserBonusService; //getuserbonus getuserbonusevents
    userBonusEventService: UserBonusEventService;
    walletService: WalletService;
    
    constructor(props : RouteComponentProps){
        super(props);
        this.userBonusService = getContainer().getUserBonusService();
        this.userBonusEventService = getContainer().getUserBonusEventService();
        this.walletService = getContainer().getWalletService();
        
        this.state = { 
            userBonusId: (this.props.match.params as any).id,
            userId: (this.props.match.params as any).userId,
            userBonusView : {},  
            validationMap : {}, 
            showCancelModal: false
        };
        
    }

    componentDidUpdate(prevProps : RouteComponentProps, prevState : State) {
        if((prevProps.match.params as any).id !== (this.props.match.params as any).id)  {
            this.refreshContent();
        }
    }

    loadContent(): void | Promise<any> {
        let id = (this.props.match.params as any).id;
        this.setState({userBonusId: undefined})
        //UserBonus
        this.userBonusService.getEntity(id).then((userBonus:UserBonusView)=>{
            this.setState({
                userBonusView: userBonus, 
                userBonusId: userBonus.id
            })
        })
    }


    getTitle(): string {
        return "Bonus Details";
    }
    
   

    onAction(item : UserBonusEvent, action : string):Promise<UserBonusEvent | void> | undefined{
        
        return undefined;
    }
    
    onSubmitError?: (() => void) | undefined;
   
    onSubmit() : void | Promise<any> {
        
    }
    formDidUpdate(formModel: UserBonusView, validationMap?: any): void {
        this.setState({userBonusView : formModel, validationMap : validationMap})
    }

    renderActions(){
        if (!this.state.userBonusView) return (<div></div>);

        return (<Fragment>
            <ConfirmModal
                show={this.state.showCancelModal}
                okLabel={"Cancel Bonus"}
                heading={"Cancel"}
                description={"The bonus status will be cancelled, no more contributions nor payouts will be accepted."}
                okClassName={"btn btn-danger"}
                hideCancelButton={true}
                onOk={()=>{
                    this.userBonusService.cancelUserBonus(this.state.userId!,this.state.userBonusId!).then((x:any)=>{
                        this.setState({showCancelModal: false});
                        this.loadContent();
                    }).catch(()=>{
                        this.setState({showCancelModal: false});
                    })
                }}
                onCancel={()=>{ this.setState({showCancelModal: false})}}
                />
        </Fragment>)
    }
   
    renderContent(){
        if(!this.state.userBonusView){
            return <span>Not Found</span>
        }
        return (
            <Fragment>
                <div className="row">
                    <div className={"col-lg-12"}>
                        <div className={"row"}>
                            <div className="col-lg-12">
                                <div className={"card-box"}>
                                    <h5>Bonus Amount{this.state.userBonusView.totalBonusAmount!+" "+this.state.userBonusView.currency}</h5>
                                    <table className={"table table-striped"}>
                                        <tbody>
                                            <tr>
                                                <td>ID:</td>
                                                <td>{this.state.userBonusView.id}</td>
                                            </tr>
                                            <tr>
                                                <td>User:</td>
                                                <td><NavLink to={"/user/"+(this.props.match.params as any).userId}>{(this.props.match.params as any).userId}</NavLink></td>
                                            </tr>
                                            <tr>
                                                <td>Created:</td>
                                                <td>{formatDate(this.state.userBonusView.timestamp)}</td>
                                            </tr>
                                            <tr>
                                                <td>Bonus Config:</td>
                                                <td>{this.state.userBonusView.bonusConfig!==undefined && (
                                                    this.state.userBonusView.bonusConfig.name
                                                )}</td>
                                            </tr>
                                            <tr>
                                                <td>Status:</td>
                                                <td>{this.state.userBonusView.status}</td>
                                            </tr>
                                            <tr>
                                                <td>Current Turnover:</td>
                                                <td>{this.state.userBonusView.currentTurnover}</td>
                                            </tr>
                                            <tr>
                                                <td>Turnover Requirement:</td>
                                                <td>{this.state.userBonusView.turnoverRequirement}</td>
                                            </tr>
                                            <tr>
                                                <td>Amount:</td>
                                                <td>{this.state.userBonusView.totalBonusAmount}</td>
                                            </tr>
                                            <tr>
                                                <td>Offer Id:</td>
                                                <td> <NavLink to={"/bonus/offer/"+this.state.userBonusView.bonusOfferId}>{this.state.userBonusView.bonusOfferId}</NavLink></td>
                                            </tr>
                                            <tr>
                                                <td>Payout #:</td>
                                                <td>{this.state.userBonusView.currentTotalPayouts}</td>
                                            </tr>
                                            <tr>
                                                <td>Paid:</td>
                                                <td>{this.state.userBonusView.currentPayoutAmount}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                           
                            <div className="col-lg-12">
                                <div className={"card-box"}>
                                    <h5>Event Logs</h5>
                                    {this.state.userBonusId && (
                                        <UserBonusEventListView userBonusId={this.state.userBonusId} />
                                    )}
                                    
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className={"card-box"}>
                                    <h5>User Bonus Transactions</h5>
                                    {this.state.userBonusId && (
                                        <UserBonusEntriesList bonusId={this.state.userBonusId} service={this.walletService}/>
                                    )}
                                    
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className={"card-box"}>
                                    <h5>Actions</h5>
                                    <Button onClick={()=>this.loadContent()}  style={{marginRight: "2px"}} className={"btn btn-primary"}>Refresh</Button>
                                    {this.state.userBonusView.status === UserBonusStatus.RUNNING && (
                                        <Button onClick={()=>this.setState({showCancelModal: true})}  style={{marginRight: "2px"}} className={"btn btn-danger"}>Cancel</Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderActions()}
            </Fragment>
        );
    }
    

}

export default withRouter(UserBonusesView);